// 라우트 handle 의 접근 규칙이 검사하는 Unleash 플래그입니다
export enum ROUTE_FEATURE_FLAG {
  API_KEY_ENABLED = 'vuex.sapporo.apiKeyEnabled',
  META_MANAGEMENT_ENABLED = 'vuex.sapporo.metaManagementEnabled',
  META_MANAGEMENT_DASHBOARD_ENABLED = 'vuex.sapporo.metaManagementDashboardEnabled',
  MODELING_DISABLED = 'vuex.sapporo.modelingDisabled',
  QR_INVITATION = 'vuex.miri.qrInvitation',
}

// NOTE: 요금제 기능(/pricing, 관리자 설정 개편, 구매 요청 진입) 전체를 여닫는 Unleash 플래그입니다
export const PRICING_FLAG = 'vuex.sapporo.pricingEnabled';

export const FRAME_HISTORY_PANEL_FLAG = 'vuex.sapporo.frameHistoryPanelEnabled';

// Contact sales 버튼 A/B 테스트용 Unleash 토글 이름입니다. variant 는 'A' | 'B' 를 사용합니다
export const CONTACT_SALES_AB_TEST_FLAG =
  'vuex.sapporo.signinContactSalesAbTest';

export const STANDALONE_FLAG = 'vuex.global.standalone';

export const BOX_IMPORT_FLAG = 'vuex.global.boxImport';

export const RESET_PASSWORD_RESEND_LINK_INTERVAL_FLAG =
  'vuex.sapporo.resetPasswordResendLinkInterval';

export const IMPROVED_REMOVE_FLAG = 'vuex.sapporo.improvedRemoveEnabled';

export const FIND_TASK_BY_OBJECT_PATH_FLAG =
  'vuex.sapporo.findTaskByObjectPathEnabled';

export const TASK_REWORK_FLAG = 'vuex.sapporo.taskReworkEnabled';

export const TASK_RANGE_REDISTRIBUTION_FLAG =
  'vuex.sapporo.taskRangeRedistributionEnabled';

export const DEFAULT_DISTANCE_VALUE_FLAG = 'vuex.sapporo.defaultDistanceValue';

export const SAMPLE_FILE_LIST_FLAG = 'vuex.sapporo.sampleFileList';

export const JP_ENABLED_FLAG = 'vuex.sapporo.jpEnabled';

export const CN_ENABLED_FLAG = 'vuex.sapporo.cnEnabled';

export const COLLECTION_METADATA_REVIEW_FLAG =
  'vuex.sapporo.collectionMetadataReviewEnabled';

export const COLLECTION_SEARCH_FLAG = 'vuex.sapporo.collectionSearchEnabled';
